import * as React from "react";
import { connect } from 'react-redux';
import { setImageInfo } from '../actions/registrationActions';
import ImageUploading from "react-images-uploading";
import ProgressCircle from './ProgressCircle'; 
import photoIDFront from '../../assets/photoIDSmall.png';
import photoIDBack from '../../assets/photoIDBack.png';
import { uploadIDImages } from './registration-utils';
import RegFlowHeader from './RegFlowHeader';
import ProgressJoint from "./ProgressJoint";
import ProcessRegistration from './ProcessRegistration';

import formStyles from './Registration.module.css';
import styles from './Upload.module.css';

/**
 *  Upload front and back images of ID to Firebase 
 */
class UpLoadID extends React.Component {
  
  constructor(props) {
    super();
    this.state = {
      userImages: [],
      imageInfoSet: [],
      uploadPct: -1,
      error: null,
      /* after image info is returned we'll load the ProcessRegistration component */
      processRegistration: false
    };
  }
 
  render() {

    // Temporarily store images in a directory that's a base64 encoding of their email 
    const { email } = this.props;
    const encodedEmail = window.btoa(email.trim());

    const requiredImageCount = 2;
    
    const onSelectImage = imageList => {
      console.log(imageList);
      // data for submit
      this.setState({ userImages: imageList});
    };
  
    // runs for each image upload
    const onUploadComplete = (imageInfo) => {
      this.setState({ imageInfoSet: [imageInfo, ...this.state.imageInfoSet]},
        () => {
          // when uploaded, pass the image urls to redux
          if (this.state.imageInfoSet.length === 2) {
            this.props.setImageInfo({
              primary: this.state.imageInfoSet[0],
              secondary: this.state.imageInfoSet[1]
            });
            this.setState({ processRegistration: true });
          }
        }
      );
    };
  
    const onUploadProgressChange = (pctComplete) => {
      this.setState({ uploadPct: (parseInt(pctComplete, 10)) });
    }
  
    const instructionDetails = [
      { placeholderSrc: photoIDFront, label: 'Front', buttonText: 'Select ID Front Image'}, 
      { placeholderSrc: photoIDBack, label: 'Back', buttonText: 'Select ID Back Image'}
    ]; 
  
    return (
      <div className={formStyles.formOnlyPage}>
        <RegFlowHeader pageTitle="Upload Identification" backLink="/signUp/phoneNumber" />
        <div className={formStyles.regFlowForm} >
          <div className={`${formStyles.formHeader} ${formStyles.formHeaderWide}`}>
            We'll need to see your ID to ensure you're 21
          </div>
          
          <div className={formStyles.formInstructions} >
            Take a clear photo of your government-issued ID. We'll
            verify your information to ensure you're legally allowed to
            purchase cannabis. Your personal information is private
            and protected by enterprise-level security.
          </div>
        </div> 
  
        <ImageUploading 
          onChange={onSelectImage} 
          maxNumber={this.requiredImageCount}
          multiple>
          {({ imageList, onImageUpload, onImageRemoveAll }) => (
            <>
              <div className={styles.imageGrid}>
                {/* display the user-uploaded images */}
                { imageList.map((image, idx) => (
                  <div key={image.key} className={styles.imageItem}>
                    <div className={styles.placeholderLabel}>{instructionDetails[idx].label}</div>
                    <div className={styles.imageWrapper}>
                      <img src={image.dataURL} alt="" />
                      <span className={styles.alternateButton} onClick={image.onUpdate}>Update Image</span>
                    </div>
                  </div>
                ))}
    
                {/* add image placeholders for any missing images */}
                {/* allow click on placeholder to upload for currently needed image only */}
                { imageList.length < requiredImageCount && 
                  instructionDetails.slice(imageList.length, requiredImageCount).map((instruction, idx) => (
                    <div key={instruction.label} className={`${styles.placeholderItem} ${styles.imageItem}`}>
                       <div className={styles.placeholderLabel}>{instructionDetails[imageList.length + idx].label}</div>
                      <img src={instruction.placeholderSrc} alt="" 
                           onClick={ idx === 0 ? onImageUpload : ()=>{}} 
                      />    
                    </div>
                  ))
                }
              </div>
              <div className={styles.imageGrid}>
                {/* upload errors will go here */}
                {this.state.error !== null && (
                  <div className={styles.formError}>
                    {this.state.error}
                  </div>
                )}

                {/* 
                  TODO: This would be better implemented as uploadPct1 and uploadPct2 so we're not mixing 
                  the data for both images into a single measurement: 0, 0, 79, 49, 100, 100. 
                */} 
                { this.state.uploadPct > -1 && 
                   <div className={styles.progressWrap}>
                     <ProgressCircle onGreen percentageInt={parseInt(this.state.uploadPct, 10)} />     
                  </div> 
                }
                
                <div className={styles.imageUploadButtons}>
                  { imageList.length < requiredImageCount
                    ? <button
                        className={`${formStyles.formButton} ${formStyles.formSubmit}`}
                        onClick={onImageUpload}
                      >
                        {instructionDetails[imageList.length]['buttonText']} 
                      </button>
                    : <button
                        className={`${formStyles.formButton} ${formStyles.formSubmit}`}
                        onClick={event => {
                          event.preventDefault();
                          uploadIDImages(this.state.userImages, encodedEmail, onUploadComplete, onUploadProgressChange);
                        }}>
                        Upload My ID
                      </button>
                  }
                  
                </div>    
              </div>
              { this.state.processRegistration && 
                <ProcessRegistration />
              }              
              </>       
          )}
        </ImageUploading>
        <ProgressJoint currentStep={2} />
      </div>
    );
  }
};  

const mapStateToProps = (state)=>{
  return {
    email: state.email,
    imageInfo: state.photo_ids
  }
}

const mapDispatchToProps = (dispatch)=>{
  return {
    setImageInfo: (imageInfo)=>{dispatch(setImageInfo(imageInfo))},
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UpLoadID);